import React from 'react';
import styled from 'styled-components';
import withFeedback from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/feedback';
import LikeSVG from '@catalogo/ui-americanas-desktop-svg/like-v2.svg';

const Text = styled.p`
  font-size: 16px;
  font-weight: 600;
  word-break: break-word;
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #f1f1f1;
`;

const FeedbackText = styled(Text)`
  font-size: 20px;
  color: ${({ theme }) => theme.textColor};
  font-weight: ${({ theme }) => theme.fontWeight.title};
`;

const LikeAndDislike = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;

  div:nth-child(2) {
    margin-left: 20px;
  }
`;

const WrapperButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const LikeUI = styled(LikeSVG)`
  width: 28px;
`;

const Like = styled(LikeUI)`
  stroke: ${({ theme, $feedback }) => ($feedback ? '#369E26' : theme.grey.dark)};
`;

const Dislike = styled(LikeUI)`
  transform: rotate(180deg);
  stroke: ${({ theme, $feedback }) => ($feedback ? '#D71627' : theme.grey.dark)};
`;

const Count = styled.span`
  font-size: 16px;
  margin-right: 15px;
  margin-left: 3px;
  color: ${({ theme }) => theme.textColor};
`;

export const Feedback = ({ feedback, handleClick }) => {
  const handleLike = () => handleClick('like', feedback.like);
  const handleDislike = () => handleClick('dislike', feedback.dislike);

  return (
    <Wrapper>
      <FeedbackText>a resposta foi útil?</FeedbackText>
      <LikeAndDislike>
        <WrapperButton onClick={handleLike}>
          <Like $feedback={feedback.like}>
            <LikeSVG />
          </Like>
          <Count>({feedback.likeCount})</Count>
        </WrapperButton>
        <WrapperButton onClick={handleDislike}>
          <Dislike $feedback={feedback.dislike}>
            <LikeSVG />
          </Dislike>
          <Count>({feedback.dislikeCount})</Count>
        </WrapperButton>
      </LikeAndDislike>
    </Wrapper>
  );
};

export default withFeedback(Feedback);
